export default __webpack_public_path__ + "static/media/step_01_active.e0565eb1.svg";